/**
 * Scopes required for Adobe IMS.
 */
export const ADOBE_IMS_V4_SCOPE = [
  'AdobeID',
  'openid',
  'additional_info.user_image_url',
  'account_cluster.read',
];
